import { Stack, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"

const CardSectionHeader = ({title, subTitle = null, ...props}) => {

    const { t } = useTranslation();
    
    if(!subTitle) {
        return (
            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom {...props}>
                {t(title)}
            </Typography>
        )
    }

    return (
        <Stack spacing={1}>
            <Typography style={{ fontWeight: "bold", fontSize: 14 }}>{title}</Typography>
            <Typography style={{ fontSize: 13 }}>{t(subTitle)}</Typography>
        </Stack>
    )
}

export default CardSectionHeader;